export const hpColor = '#3DD779'
export const hpColorPlan = '#549EF7'
export const colors = ['#fd8d0a', '#a5d870', '#a177c1', '#c92d2b', '#fd8d0a', '#b6d5fb', '#a5d870']
export const TABLE_HIERARCHY_FIELD = 'ParentId'
export const TABLE_KEY_FIELD = 'EntryId'
export const SOB_LABEL = 'SOB, %'
